import Bellhop from '@/components/HomebuyerOffers/Bellhop.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers/Bellhop',
  name: RouteNames.Bellhop,
  component: Bellhop,
};

export default route;
